// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"c1136650","922":"c1136650"}[chunkId] + ".chunk.css";
};